import { useBranches } from '@user/components/Location/AddServiceLocationForm/hooks/useBranches'
import { useDivisions } from '@user/components/Location/AddServiceLocationForm/hooks/useDivisions'
import { useLocationTypes } from '@user/components/Location/AddServiceLocationForm/hooks/useLocationTypes'

export function useData() {
  const [locationTypesLoading, locationTypes] = useLocationTypes()
  const [divisionsLoading, divisions] = useDivisions()
  const [branchesLoading, branches] = useBranches()

  const loading = locationTypesLoading || divisionsLoading || branchesLoading

  return {
    loading,
    locationTypes,
    divisions,
    branches,
  }
}
